<template>
    <div class="Join">
        <!-- s: header -->
        <header>
            <img src="@/assets/images/top-bg-basic.png" width="100%" />
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-noscroll">
            <h2 class="header-title">회원정보입력</h2>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="아이디 (4자 ~ 10자 이내)"
                               maxlength="10"
                               v-model="strUserId" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strUserId'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="담당자 이름"
                               v-model="strEmpName" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strEmpName'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-item">
                        <input type="password"
                               placeholder="비밀번호  (6자 ~ 14자 이내)"
                               v-model="strPassWd"
                               maxlength="14" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strPassWd'">
                    {{errorMsg}}
                </p>
            </transition>

            <div class="form-box">
                <div class="input-box">
                    <div class="input-item">
                        <input type="password"
                               placeholder="비밀번호 재확인"
                               v-model="strPassWdConfirm"
                               maxlength="14" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strPassWdConfirm'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box mrg-top-35">
                <div class="input-box">
                    <div class="input-item">
                        <input type="text"
                               placeholder="상호명"
                               v-model="strAgentName" />
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strAgentName'">
                    {{errorMsg}}
                </p>
            </transition>
            <div class="form-box">
                <div class="input-box">
                    <div class="input-item input-item-phone">
                        <select v-model="strPhoneNumber1">
                            <option>010</option>
                            <option>011</option>
                            <option>016</option>
                            <option>017</option>
                            <option>018</option>
                            <option>019</option>
                        </select>
                    </div>
                    <div class="input-item">
                        <input type="number"
                               placeholder=""
                               pattern="[0-9]*"
                               v-model="strPhoneNumber2"
                               maxlength="8"
                               @keyup="textLenFunc($event,8)" />
                    </div>
                    <div class="input-item input-item-button"
                         v-if="!authSmsConfirmResult">
                        <button class="btn-auth"
                                @click="smsAuthSendFunc">
                            인증
                        </button>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <p class="error-msg"
                   v-show="errorField == 'strPhoneNumber2'">
                    {{errorMsg}}
                </p>
            </transition>
            <template v-if="!authSmsConfirmResult">
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-item">
                            <input type="number"
                                   placeholder="인증번호"
                                   pattern="[0-9]*"
                                   v-model="strCertCodeConfirm"
                                   maxlength="6"
                                   @keyup="textLenFunc($event,6)" />
                        </div>
                        <div class="input-item input-item-button">
                            <button class="btn-confirm"
                                    @click="smsAuthCheckFunc">
                                확인
                            </button>
                        </div>
                    </div>
                </div>
                <transition name="fade">
                    <p class="error-msg"
                       v-show="errorField == 'strCertCodeConfirm' ||
                                errorField == 'strConfirmCode' ||
                                errorField == 'strAuthSmsConfirm'">
                        {{errorMsg}}
                    </p>
                </transition>
            </template>
            <template v-else>
                <div class="form-box">
                    <div class="input-box">
                        <div class="input-item" style="color:#017ff0">
                            {{ $store.state.messagesList.THE_NUMBER_YOU_ENTERED_HAS_BEEN_VERIFIED }}
                        </div>
                    </div>
                </div>
            </template>
            <p class="join-msg mrg-top-35">
                사업자 정보는 PC에 로그인하여 입력해주세요
            </p>
            <div class="flex justify-between mrg-top-35 mrg-btm-20">
                <router-link class="btn-big btn-white width-45"
                             tag="button"
                             to="/login">
                    취소
                </router-link>
                <button class="btn-big btn-bule width-45"
                        @click="formSendFunc">
                    가입하기
                </button>
            </div>

        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
export default {
    name: 'Join',
    data() {
        return {
            strUserId:'',                   // 신규 아이디
            strEmpName:'',                  // 담당자 이름
            strPassWd:'',                   // 비밀번호
            strPassWdConfirm:'',            // 비밀번호 재확인
            strAgentName:'',                // 상호명
            strPhoneNumber1:"010",          // 담당자 휴대폰 번호 - 식별번호
            strPhoneNumber2:'',             // 담당자 휴대폰 번호 - 고유번호
            strConfirmCode:'',              // 인증번호 ( 서버에서 전달한 코드)
            strCertCodeConfirm:'',          // 인증번호 ( 사용자 입력 번호)
            authSmsConfirmResult:false,     // 인증확인(사용자 클릭여부)
            errorField:'',                  // error 항목
            errorMsg:'',                    // error 메시지
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.loginMoveFunc();
        },
        // 인증번호 발송
        smsAuthSendFunc(){
            this.strConfirmCode = '';

            let formData = new FormData();
            formData.append('strPhoneNumber', this.strPhoneNumber1+this.strPhoneNumber2);

            this.ajaxPost('/api/v1/join/sendSms', formData,this.smsAuthSendFuncResult);
        },
        // 인증번호 발송 결과
        smsAuthSendFuncResult(response){
            let result = response.result;

            this.toastMsg(result.resultNoti.message,1500)
            if (result.code == 0){
                this.strConfirmCode = result.strCertCode;
            }
        },
        // 인증번호 확인
        smsAuthCheckFunc(){
            if (!this.strConfirmCode){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.PLEASE_ENTER_THE_AUTHENTICATION_NUMBER_RECEIVED;
                return false;
            }

            if (!this.strCertCodeConfirm){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.PLEASE_ENTER_THE_AUTHENTICATION_NUMBER;
                return false;
            }

            if (this.strConfirmCode != this.strCertCodeConfirm){
                this.errorField = 'strCertCodeConfirm';
                this.errorMsg = this.$store.state.messagesList.THE_AUTHENTICATION_NUMBER_DOES_NOT_MATCH;
                return false;
            }

            this.authSmsConfirmResult = true;
        },
        // 가입하기
        formSendFunc(){
            let formData = new FormData();
            formData.append('strUserId', this.strUserId);
            formData.append('strEmpName', this.strEmpName);
            formData.append('strPassWd', this.strPassWd);
            formData.append('strPassWdConfirm', this.strPassWdConfirm);
            formData.append('strAgentName', this.strAgentName);
            formData.append('strPhoneNumber1', this.strPhoneNumber1);
            formData.append('strPhoneNumber2', this.strPhoneNumber2);
            formData.append('strConfirmCode', this.strConfirmCode);
            formData.append('strCertCodeConfirm', this.strCertCodeConfirm);
            formData.append('strAuthSmsConfirm', this.authSmsConfirmResult ? 'Y' : 'N');

            this.ajaxPost('/api/v1/join/member', formData,this.formSendFuncResult);
        },
        // 가입하기 결과
        formSendFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                let data={};
                data.strUserId = this.strUserId;
                data.strEmpName = this.strEmpName;
                this.$router.push({ name: 'JoinResult', params: {data} })
            }else{
                if (result.resultNoti.type === 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
    }
}
</script>

<style scoped>
    .error-msg {padding-left: 0;}
    .btn-auth{background-color: #a0a0a0;color: #fff;width: 100%;border: 0;height: 100%;border-radius: 5px;font-size: 16px;}
    .btn-confirm {background-color: #00b7ee;color: #fff;width: 100%;border: 0;height: 100%;border-radius: 5px;font-size: 16px;}
    .join-msg {text-align: center;color: #7f7f7f;font-size: 14px;font-weight: 400;}
</style>
